import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { LogOut, User, Settings, ChevronDown, ChevronUp } from 'lucide-react';

const UserProfile = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSignOut = () => {
    logout();
    navigate('/sign-in');
  };

  const handleOpenProfile = () => {
    setIsExpanded(false);
    navigate('/account');
  };

  return (
    <div className="user-profile">
      <div className="user-profile-main">
          <div className="user-info" onClick={() => setIsExpanded(!isExpanded)}>
          <div className="user-avatar">
            <div className="avatar-placeholder">
              <User size={20} />
            </div>
          </div>
          <div className="user-details">
            <div className="user-name">
              {user?.name || 'User'}
            </div>
            <div className="user-email">
              {user?.email}
            </div>
          </div>
          <button className="expand-btn">
            {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </button>
        </div>
        
        {isExpanded && (
          <div className="user-profile-menu">
            <button 
              onClick={handleOpenProfile}
              className="profile-menu-item"
            >
              <Settings size={16} />
              <span>Account Settings</span>
            </button>
            <button 
              onClick={handleSignOut}
              className="profile-menu-item sign-out"
            >
              <LogOut size={16} />
              <span>Sign out</span>
            </button>
          </div>
        )}
      </div>
      
      <style>{`
        .user-profile {
          border-top: 1px solid #e5e7eb;
          background: #f9fafb;
        }
        
        .user-profile-main {
          padding: 1rem;
          width: 100%;
          box-sizing: border-box;
        }
        
        .user-info {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          cursor: pointer;
          padding: 0.5rem;
          border-radius: 0.5rem;
          transition: background-color 0.2s;
          width: 100%;
          box-sizing: border-box;
        }
        
        .user-info:hover {
          background: #f3f4f6;
        }
        
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          background: #e5e7eb;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        
        .avatar-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .avatar-placeholder {
          color: #6b7280;
        }
        
        .user-details {
          flex: 1;
          min-width: 0;
          overflow: hidden;
          max-width: 100%;
        }
        
        .user-name {
          font-weight: 600;
          color: #1f2937;
          font-size: 0.875rem;
          line-height: 1.25rem;
        }
        
        .user-email {
          color: #6b7280;
          font-size: 0.75rem;
          line-height: 1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 100%;
          display: block;
        }
        
        .expand-btn {
          background: none;
          border: none;
          color: #6b7280;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 0.25rem;
          transition: all 0.2s;
          flex-shrink: 0;
        }
        
        .expand-btn:hover {
          background: #e5e7eb;
          color: #374151;
        }
        
        .user-profile-menu {
          margin-top: 0.5rem;
          border-top: 1px solid #e5e7eb;
          padding-top: 0.5rem;
          animation: slideDown 0.2s ease-out;
        }
        
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .profile-menu-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          width: 100%;
          padding: 0.75rem;
          border: none;
          background: none;
          color: #374151;
          border-radius: 0.375rem;
          cursor: pointer;
          font-size: 0.875rem;
          transition: all 0.2s;
          text-align: left;
        }
        
        .profile-menu-item:hover {
          background: #f3f4f6;
          color: #1f2937;
        }
        
        .profile-menu-item.sign-out {
          color: #dc2626;
        }
        
        .profile-menu-item.sign-out:hover {
          background: #fef2f2;
          color: #b91c1c;
        }
        
        .profile-menu-item span {
          font-weight: 500;
        }
      `}</style>
    </div>
  );
};

export default UserProfile; 